import { FC, ReactElement, useState, useEffect, useMemo } from "react"
import MotivyLogo from "../../assets/imagotipo-white.svg"
import OutpointsLogo from "../../assets/outpoints-logo.png"

import "./LoaderPage.css"
import { Stack, Typography, CircularProgress } from "@mui/material"

const LoaderPage: FC = (): ReactElement => {
  const [actualDomain] = useState(window.location.hostname)
  const [imagesLoaded, setImagesLoaded] = useState(false)
  const [loadingProgress, setLoadingProgress] = useState(0)

  // Memoizar la detección de Outpoints para evitar recálculos
  const isOutpoints = useMemo(
    () => actualDomain.includes("outp"),
    [actualDomain]
  )

  // Precargar imágenes críticas
  useEffect(() => {
    const preloadImages = () => {
      const imagesToLoad = isOutpoints
        ? [OutpointsLogo, MotivyLogo]
        : [MotivyLogo]
      let loadedCount = 0

      const onImageLoad = () => {
        loadedCount++
        setLoadingProgress((loadedCount / imagesToLoad.length) * 100)
        if (loadedCount === imagesToLoad.length) {
          setImagesLoaded(true)
        }
      }

      const onImageError = () => {
        loadedCount++
        setLoadingProgress((loadedCount / imagesToLoad.length) * 100)
        if (loadedCount === imagesToLoad.length) {
          setImagesLoaded(true)
        }
      }

      imagesToLoad.forEach((src) => {
        const img = new Image()
        img.onload = onImageLoad
        img.onerror = onImageError
        img.src = src
      })
    }

    preloadImages()
  }, [isOutpoints])

  return (
    <div className="loader-container">
      <div className={"loader"}>
        {isOutpoints ? (
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            {imagesLoaded ? (
              <>
                <img
                  style={{ width: "80%" }}
                  src={OutpointsLogo}
                  alt="Outpoints Logo"
                  loading="eager"
                />
                <Stack
                  direction={"row"}
                  maxWidth={"80%"}
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}
                >
                  <Typography
                    variant={"inherit"}
                    fontSize={15}
                    color={"white"}
                    sx={{ pt: "8px" }}
                  >
                    developed by
                  </Typography>
                  <img
                    style={{ width: "50%" }}
                    src={MotivyLogo}
                    alt="Motivy Logo"
                    loading="eager"
                  />
                </Stack>
              </>
            ) : (
              <CircularProgress
                size={60}
                sx={{ color: "white" }}
              />
            )}

            {/* Indicador de progreso sutil */}
            {!imagesLoaded && (
              <Typography
                variant="inherit"
                color="white"
                sx={{ mt: 1, opacity: 0.7, fontSize: "0.75rem" }}
              >
                {Math.round(loadingProgress)}%
              </Typography>
            )}
          </Stack>
        ) : (
          <>
            <img
              src={MotivyLogo}
              alt="Motivy Logo"
              width={"100%"}
              loading="eager"
              fetchPriority="high"
            />
            <div className="text-animation-container">
              <div className="text-container">
                <div>El poder del reconocimiento</div>
                <div>the power of recognition</div>
                <div>le pouvoir de la reconnaissance</div>
                <div>o poder do reconhecimento</div>
                <div>сила признания</div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default LoaderPage
